import {
  CREATE_COLOR_FAILURE,
  CREATE_COLOR_REQUEST,
  GET_ALL_COLOR_REQUEST,
  GET_ALL_COLOR_SUCCESS,
  GET_ALL_COLOR_FAILURE,
  DELETE_COLOR_REQUEST,
  DELETE_COLOR_FAILURE,
  UPDATE_COLOR_REQUEST,
  UPDATE_COLOR_FAILURE,
  CREATE_COLOR_SUCCESS,
  UPDATE_COLOR_SUCCESS,
  DELETE_COLOR_SUCCESS,
} from "./ActionType";

const initialState = {
  colors: [],
  loading: false,
  color: null,
  error: "",
};

export const vendorProductColorReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COLOR_REQUEST:
      return { ...state, loading: true };

    case CREATE_COLOR_SUCCESS:
      return { ...state, loading: false, error: "", color: action.payload };

    case CREATE_COLOR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_COLOR_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_COLOR_SUCCESS:
      return { ...state, loading: false, error: "", colors: action.payload };

    case GET_ALL_COLOR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_COLOR_REQUEST:
      return { ...state, loading: true };

    case DELETE_COLOR_SUCCESS:
      return { ...state, loading: false, error: "", color: action.payload };

    case DELETE_COLOR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_COLOR_REQUEST:
      return { ...state, loading: true };

    case UPDATE_COLOR_SUCCESS:
      return { ...state, loading: false, error: "", color: action.payload };

    case UPDATE_COLOR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
